import React from 'react';
import cn from 'classnames';
import Markup from 'components/Markup';
import Title from 'components/UI/Title';
import Image from 'components/UI/Image';

import * as styles from './client.module.scss';

export function Component({ content, className }) {
  const { title, description, location, image } = content;
  const { label, countryName } = location;

  return (
    <div className={cn(className, styles.wrapper)}>
      <div>
        <Title tag="h2" size="h3">
          {title}
        </Title>
        <Markup tag="p" className={styles.description}>
          {description}
        </Markup>
        <div className={styles.location}>
          <span className={styles.locationLabel}>{label}</span>
          <span className={styles.locationName}>{countryName}</span>
        </div>
      </div>
      <Image
        src={image}
        alt={`${location} on the map`}
        className={styles.picture}
        classImage={styles.img}
      />
    </div>
  );
}
